import React, { useState, useEffect } from "react";
import "./rrss.css";
import { getJsonFromStorage } from "../../../../utils/getJsonFromStorage";
import Spinner from "react-bootstrap/Spinner";

function Redes() {
  const [instagramData, setInstagramData] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchInstagramData = async () => {
      const jsonData = await getJsonFromStorage("instagramData.json");
      if (jsonData?.media?.data) {
        setInstagramData(jsonData);
      } else {
        setError(true);
      }
      setLoading(false);
    };
    fetchInstagramData();
  }, []);

  const handleCardClick = (post) => setSelectedPost(post);
  const handleClose = () => setSelectedPost(null);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (error || !instagramData?.media?.data) {
    return <p>Error al cargar información de Instagram.</p>;
  }

  const firstGroup = instagramData.media.data.slice(0, 2);
  const secondGroup = instagramData.media.data.slice(2);

  return (
    <>
      <h1 className="rrss-title">Novedades</h1>
      <div id="rrss_block">
        <div className="rrss-group">
          {firstGroup.map((post, index) => (
            <div
              key={index}
              className="rrss"
              onClick={() => handleCardClick(post)}
            >
              <img
                src={post.thumbnail_url || post.media_url}
                alt={post.caption?.slice(0, 100) + "..." || "Instagram Post"}
              />
            </div>
          ))}
        </div>
        <div className="rrss-group">
          {secondGroup.map((post, index) => (
            <div
              key={index + 2}
              className="rrss"
              onClick={() => handleCardClick(post)}
            >
              <img
                src={post.thumbnail_url || post.media_url}
                alt={post.caption?.slice(0, 100) + "..." || "Instagram Post"}
              />
            </div>
          ))}
        </div>
      </div>

      {selectedPost && (
        <div className="expanded-card-overlay" onClick={handleClose}>
          <div
            className="expanded-card-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedPost.thumbnail_url || selectedPost.media_url}
              alt={
                selectedPost.caption?.slice(0, 30) + "..." || "Instagram Post"
              }
              className="expanded-card-image"
            />
            <div className="expanded-card-body">
              <p className="card-rrss">{selectedPost.caption}</p>
              <div className="card-rrss-buttons">
                <a
                  href={selectedPost.permalink}
                  className="purplebut card-button"
                  target="_blank"
                  rel="noreferrer"
                >
                  Ver Post
                </a>
                <button
                  className="close-button card-rrss-closebut"
                  onClick={handleClose}
                  aria-label="Close"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Redes;
